import { render, staticRenderFns } from "./NotificationToast.vue?vue&type=template&id=54da29cf&"
import script from "./NotificationToast.vue?vue&type=script&lang=js&"
export * from "./NotificationToast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports